<template>
    <section class="tk-engagements-panel">
        <div class="tk-engagements-panel__header">
            <h2>My Clients</h2>
            <q-btn
                color="primary"
                no-caps
                unelevated
                icon="add"
                label="Create Client Engagement"
                @click="$router.push({ name: 'tkCreateEngagement' })"
            />
        </div>

        <div class="tk-engagements-filters row q-col-gutter-md">
                    <div class="col-12 col-md-5">
                        <q-input
                            v-model="filters.q"
                            outlined
                            dense
                            clearable
                            debounce="300"
                            label="Search Client Engagements"
                            placeholder="Name, email, NHI or phone number"
                            @update:model-value="refresh"
                        >
                            <template v-slot:prepend>
                                <q-icon name="search" />
                            </template>
                        </q-input>
                    </div>
                    <div class="col-12 col-md-4">
                        <q-select
                            v-model="filters.service"
                            :options="serviceOptions"
                            outlined
                            dense
                            clearable
                            emit-value
                            map-options
                            label="Service"
                            @update:model-value="refresh"
                        />
                    </div>
                    <div class="col-12 col-md-3">
                        <q-select
                            v-model="filters.status"
                            :options="statusOptions"
                            multiple
                            outlined
                            dense
                            clearable
                            emit-value
                            map-options
                            label="Status"
                            @update:model-value="refresh"
                        />
                    </div>
        </div>

        <TkEngagementTable
            :rows="rows"
            :loading="loading"
            variant="my"
            no-data-message="No Client Engagements are assigned to you."
            @open="openEngagement"
        />
    </section>
</template>

<script>
import api from "@/services/api/api";
import notify from "@/services/util/notify";
import TkEngagementTable from "@/components/TkClients/TkEngagementTable.vue";
import { mapEngagementRow } from "@/services/util/tkClients";

export default {
    name: "TkClients",
    components: { TkEngagementTable },
    data() {
        return {
            loading: true,
            rows: [],
            lookups: { services: [], statuses: [] },
            filters: {
                q: "",
                service: null,
                status: ["waitlist", "active"],
            },
        };
    },
    computed: {
        serviceOptions() {
            return this.lookups.services.map(service => ({ label: service.name, value: service.code }));
        },
        statusOptions() {
            return this.lookups.statuses
                .map(status => ({ label: status.name, value: status.code }));
        },
    },
    async mounted() {
        await this.loadLookups();
        await this.refresh();
    },
    methods: {
        async loadLookups() {
            try {
                const res = await api.tkPeople.getEngagementLookups();
                this.lookups = res.data;
                this.filters.status = this.lookups.statuses
                    .filter(status => status.code !== "exited")
                    .map(status => status.code);
            } catch (error) {
                notify.error("Failed to load Client Engagement options", "top");
            }
        },
        async refresh() {
            this.loading = true;
            try {
                const res = await api.tkPeople.listServiceEngagements({
                    q: this.filters.q || undefined,
                    service: this.filters.service || undefined,
                    status: this.filters.status?.join(",") || undefined,
                    limit: 200,
                });
                this.rows = (res.data || []).map(mapEngagementRow);
            } catch (error) {
                notify.error("Failed to load Client Engagements", "top");
            } finally {
                this.loading = false;
            }
        },
        openEngagement(row) {
            this.$router.push({
                name: "tkEngagementDetail",
                params: { personId: row.tk_person_id, engagementId: row.id },
            });
        },
    },
};
</script>
